import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompareProfileComponent } from './compare-profile/compare-profile.component';
import {CompareRoutingModule} from './compare-routing.module';
import {ShareModule} from '../share/share.module';
import { CompareGenerateComponent } from './compare-generate/compare-generate.component';
import { CompareListComponent } from './compare-list/compare-list.component';
import { CompareResultComponent } from './compare-result/compare-result.component';
import {BreadcrumbsComponent} from '../share/breadcrumbs/breadcrumbs.component';


@NgModule({
  declarations: [CompareProfileComponent, CompareGenerateComponent, CompareListComponent, CompareResultComponent],
  imports: [
    CommonModule,
    CompareRoutingModule,
    ShareModule,
    BreadcrumbsComponent
  ]
})
export class CompareModule { }
